// UI-only normalization. Server validates catalogue identities and exact stock operations.
export const finishes = ["Normal", "Reverse Holo", "Holo"];
export const exactCard = (card) => Number.isSafeInteger(Number(card?.id)) && Number(card.id) > 0 &&
  Boolean(String(card?.set_name || "").trim()) &&
  /\b\d{1,4}\s*\/\s*\d{1,4}\b/.test(String(card?.name_and_number || ""));
export const wholeQty = (qty) => /^[1-9]\d*$/.test(String(qty)) &&
  Number.isSafeInteger(Number(qty)) && Number(qty) <= 2147483647 ? Number(qty) : null;
export const validCost = (amount) => /^\d+(?:\.\d{1,4})?$/.test(String(amount ?? "").trim()) &&
  Number.isFinite(Number(amount)) && Number(amount) <= 999999.9999;
export const costReady = (batch) => Boolean(batch?.batch_cost_reviewed_at) && batch?.batch_unit_cost != null;
export const activeRows = (rows) => rows.filter(row => !row.voided_at);
export const stagedRows = (rows) => activeRows(rows).filter(row => !row.inventory_applied_at);
export const summary = (rows) => {
  const active = activeRows(rows);
  const staged = stagedRows(rows);
  const distinct = new Set(active.map(row => `${row.catalog_card_id}:${row.card_variant}`)).size;
  return { entries: active.length, stagedCount: staged.reduce((total, row) => total + Number(row.quantity || 0), 0),
    receivedCount: active.filter(row => row.inventory_applied_at).reduce((total, row) => total + Number(row.quantity || 0), 0), distinct,
    removed: rows.length - active.length };
};
export const snapshot = (rows) => stagedRows(rows).map(row => ({ id: Number(row.id), revision: Number(row.revision || 1) }))
  .sort((a, b) => a.id - b.id);
export const newOperation = (prefix) => `${prefix}-${typeof crypto !== "undefined" && crypto.randomUUID
  ? crypto.randomUUID() : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`}`;
export const requestForCard = ({ card, finish, quantity, cost, reference, requestId }) => ({
  request_id: requestId, catalog_card_id: Number(card.id), name_and_number: card.name_and_number,
  set_name: card.set_name, card_variant: finish, quantity: wholeQty(quantity),
  source_reference: reference.trim() || null, card_condition: "Near Mint",
  inventory_apply_mode: "stage", unit_cost: Number(cost).toFixed(4),
});
const storageKey = "fc255_pure_pending_receipt_v1";
export const readPending = () => { try { return JSON.parse(localStorage.getItem(storageKey) || "null"); } catch (_) { return null; } };
export const writePending = (pending) => { try { if (pending) localStorage.setItem(storageKey, JSON.stringify(pending));
  else localStorage.removeItem(storageKey); } catch (_) {} };
